<template>
    <div>
        <alert ref="alert"></alert>

        <modal ref="modal"  @close="goBack()">
            <div class="bg-purple-900 justify-center overflow-y-auto h-full w-full flex flex-col p-10">
                <h1 class="font-light">{{ $t('new_schedule') }}</h1>
                
                <div class="w-full pt-5">
                    <select class="input w-full md:w-1/2" v-model="instance_id">
                        <option value="" disabled selected>
                            {{ $t('select_whatsapp_account') }}
                        </option>

                        <option v-for="(instance, k) in instances" :value="instance.id" :key="k">
                            {{ instance.name }}
                        </option>
                    </select>
                </div>

                <div class="w-full pt-5 flex flex-col md:flex-row">
                    <div class="w-full mr-5">
                        <select class="input w-full" multiple v-model="day_week">
                            <option value="" disabled selected>
                                {{ $t('select_days_of_week') }}
                            </option>

                            <option value="0">{{ $t('sunday') }}</option>
                            <option value="1">{{ $t('monday') }}</option>
                            <option value="2">{{ $t('tuesday') }}</option>
                            <option value="3">{{ $t('wednesday') }}</option>
                            <option value="4">{{ $t('thursday') }}</option>
                            <option value="5">{{ $t('friday') }}</option>
                            <option value="6">{{ $t('saturday') }}</option>
                        </select>

                        <div class="text-sm invisible md:visible">
                            {{ $t('hold_ctrl_to_select_multiples') }}
                        </div>
                    </div>

                    <div class="w-full flex flex-col">
                        <div class="flex flex-col">
                            <div>
                                <label for="time">{{ $t('select_the_time') }}</label>
                            </div>
                            <div class="flex">
                                <input type="time"
                                       id="time"
                                       ref="dayTimeInput"
                                       v-model="input_day_time"
                                       :placeholder="$t('day_time')"
                                       v-maska
                                       data-maska="##:##"
                                       @keyup.enter="addTime()"
                                       class="input mr-5 w-1/2">

                                <button
                                        @click="addTime()"
                                        :disabled="!input_day_time"
                                        class="w-1/2 btn bg-white text-purple-900">+</button>
                            </div>
                        </div>

                        <div class="grid grid-cols-3 my-5">
                            <div class="p-2 mb-1 bg-white rounded text-black mr-1"
                                 v-for="(time, k) in day_time" :key="k">
                                <label>
                                    {{ time }}
                                </label>

                                <button class="px-2" @click="removeTime(k)">x</button>
                            </div>
                        </div>
                    </div>
                </div>


                <div class="w-full mt-5">
                    <button class="btn btn-orange"
                            @click="add()"
                            :disabled="loading || !day_time.length">
                        {{ $t('add') }}
                    </button>
                </div>
            </div>
        </modal>
    </div>
</template>

<script>
    import {Zapin} from "@/services/Api";

    export default {

        data() {
            return {
                loading: false,
                input_day_time: null,
                instances: [],
                instance_id: '',
                day_week: [],
                day_time: []
            }
        },

        mounted() {
            this.$refs.modal.open();

            this.loadInstances();
        },

        methods: {
            addTime() {
                if(this.input_day_time) {
                    let check = this.checkTimeFormat(this.input_day_time);

                    if(check) {
                        this.day_time.push(
                            this.input_day_time
                        );

                        this.input_day_time = null;
                    }
                }

                this.$refs.dayTimeInput.focus();
            },

            removeTime(p) {
                delete this.day_time[p];
            },

            checkTimeFormat(value) {
                let time = value.split(':');

                if(time.length !== 2 || (time[0].length !== 2 || time[1].length !== 2)) {
                    this.$refs.alert.show(this.$t('invalid_time_format_error'));
                    return false;
                }

                let h = parseInt(time[0]);
                let m = parseInt(time[1]);

                if(h < 0 || h > 23 || m < 0 || m > 59) {
                    this.$refs.alert.show(this.$t('invalid_time_format_error'));
                    return false;
                }

                return true;
            },

            add() {
                if(this.input_day_time) {
                    let check = this.checkTimeFormat(this.input_day_time);

                    if(check) {
                        this.addTime();
                    }
                }

                this.store();
            },

            store() {
                this.loading = true;

                Zapin
                    .schedules()
                    .create({
                        instance_id: this.instance_id,
                        day_week: this.day_week,
                        day_time: this.day_time
                    })
                    .then(() => {
                        this.goBack();
                    })
                    .catch(err => {
                        if(err.status === 422) {
                            this.$refs.alert.showValidationErrors(err.data);
                        } else {
                            this.$refs.alert.show(this.$t('unknown_error_try_again'));
                        }
                    })
                    .finally(() => this.loading = false);
            },

            loadInstances() {
                Zapin
                    .instances()
                    .all()
                    .then(res => {
                        this.instances = res.data;
                    });

            },

            goBack() {
                // history.go(-1);
                this.$router.go(-1)
            }
        }

    }
</script>